const accessible = (target) => {
    const submenu = target.querySelector(".submenu");

    target.setAttribute("aria-expanded", "true");
    if (submenu) {
        submenu.setAttribute("aria-hidden", "false");
    }
};

const activateSingleMenu = (target) => {
    if (target) {
        target.classList.add("active");
        accessible(target);
    }
};

const disactivateAllMenus = (target) => {
    const menuItems = document.querySelectorAll(".menu__item ");

    Array.from(menuItems).forEach((item) => {
        if (item !== target) {
            const submenu = target.querySelector(".submenu");
            item.classList.remove("active");

            item.setAttribute("aria-expanded", "false");
            if (submenu) {
                submenu.setAttribute("aria-hidden", "false");
            }
        }
    });
};
const removeDesktop = (target) => {
    const submenu = target.querySelector(".submenu");
    target.classList.remove("active");
    target.setAttribute("aria-expanded", "false");
    if (submenu) {
        submenu.setAttribute("aria-hidden", "false");
    }
};
const addOverlay = () => {
    const mainOverlay = document.querySelector(".main");
    mainOverlay.classList.add("main-overlay");
};
const removeOverlay = () => {
    const mainOverlay = document.querySelector(".main");
    mainOverlay.classList.remove("main-overlay");
};

const handleA11y = () => {
    const menuItems = document.querySelectorAll(".menu__item");
    Array.from(menuItems).forEach((item) => {
        item.addEventListener("mouseover", (e) => {
            const submenu = item.querySelector(".submenu");
            const submenuItems = submenu.querySelectorAll(".submenu__item");
            const submenuItemCount = submenuItems.length;
            if (submenuItemCount === 1) submenu.classList.add("submenu-single");
            e.preventDefault();
            disactivateAllMenus(item);
            activateSingleMenu(item);
            addOverlay();
        });
        item.addEventListener("mouseout", () => {
            removeOverlay();
        });
    });
};
const openSub = (target) => {
    const nav = document.querySelector(".nav");
    if (
        target.classList.contains("active") &&
        nav.classList.contains("submenu--open")
    ) {
        target.classList.remove("active");
        nav.classList.remove("submenu--open");
    } else {
        target.classList.add("active");
        nav.classList.add("submenu--open");
        const noExpanded = target.querySelector(".mobile-no-expanded");
        if (noExpanded) {
            const title = noExpanded.querySelector(".title");
            if (title) {
                title.addEventListener("click", () => {
                    noExpanded.classList.toggle("open");
                    return;
                });
            }
        }
    }
};

const mobileMenu = () => {
    const menuItems = document.querySelectorAll(".menu__item ");
    Array.from(menuItems).forEach((item) => {
        const navTitle = item.querySelector(".main-link-title");
        if (item.classList.contains("active")) removeDesktop(item);
        navTitle.parentNode.tagName === "LI" && navTitle.addEventListener("click", (e) => {
            e.preventDefault();
            disactivateAllMenus(item);
            openSub(item);
        });
    });
};

const handleMenuToggle = () => {
    const nav = document.querySelector(".nav");

    nav.classList.add("responsive");
    const icon = document.querySelector(".global-header__hamburger-icon");

    icon &&
        icon.addEventListener("click", () => {
            if (nav.classList.contains("open")) {
                nav.classList.remove("open");
                icon.classList.remove("open");
                removeOverlay();
            } else {
                nav.classList.add("open");
                icon.classList.add("open");
                mobileMenu();
                addOverlay();
            }
        });
};
const destroyMobileMenu = (target) => {
    const nav = target.querySelector(".nav");
    if (nav.classList.contains("open")) {
        nav.classList.remove("open");
    }
    if (nav.classList.contains("submenu--open")) {
        nav.classList.remove("submenu--open");
    }
    if (nav.classList.contains("responsive")) {
        nav.classList.remove("responsive");
    }
};

const responsiveNav = () => {
    const w = window.innerWidth;
    const target = document.querySelector(".global-header");
    if (target) {
        if (w <= 1200) {
            handleMenuToggle();
        } else {
            handleA11y();
            destroyMobileMenu(target);
        }
    }
};

export default responsiveNav;
